import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LINK from 'constants/link.const';
import { FeStack } from 'errors/fe.error';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import { locationReload } from 'utils/dom/location.util';
import linkTo from 'utils/links/linkTo.util';
import navFor from 'utils/links/navFor.util';
import asObject from 'utils/objects/asObject.util';
import finishOnboarding from 'utils/salons/finishOnboarding.util';

import PopupModalContainer from 'common/PopupModal';
import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';
import OpeningHoursContainer from 'onboarding/openingHours/OpeningHours';
import { updateSalonDetails } from 'salon/actions';

class OpeningHoursWrap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFooterButtonActive: false,
      salonDetails: Object.assign({}, props.currentSalon),
      errorMessage: '',
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.currentSalon) {
      navFor('OpeningHoursWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
    }

    this.checkButton();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errorMessage) {
      this.setState({ errorMessage: nextProps.errorMessage });
    }

    if (this.props.isPosting && !nextProps.isPosting) {
      finishOnboarding({ cognitoUser: this.props.cognitoUser })
        .then(() => {
          const query = fromPropsToQuery(this.props);
          navFor('OpeningHoursWrap.componentWillReceiveProps()', this.props).push({
            // previously it was `/salon/${this.props.currentSalon.id}/day/today`
            pathname: linkTo({
              pattern: LINK.scheduleDay,
              params: { salonId: asObject(this.props.currentSalon).id || query.salonId, dateString: 'today' },
            }),
            search: fromObjectToQueryString(query),
          });
          locationReload(new FeStack({ tag: 'OpeningHoursWrap__will-receive-props' }));
        })
        .catch((e) => {
          this.setState({ errorMessage: e.message || JSON.stringify(e) });
        });
    }
  }

  onFooterButtonClicked = () => {
    this.props.updateSalonDetails(this.state.salonDetails);
  };

  onOpenCheckboxChange = (dayName, value) => {
    const shortDayName = dayName.substring(0, 3).toLowerCase();
    const salonDetails = Object.assign({}, this.state.salonDetails);
    salonDetails[`${shortDayName}_open`] = value;
    this.setState({ salonDetails });
  };

  onOpenTimeChange = (dayName, newTime) => {
    const shortDayName = dayName.substring(0, 3).toLowerCase();
    const salonDetails = Object.assign({}, this.state.salonDetails);
    salonDetails[`${shortDayName}_open_time`] = newTime.format('HH:mm:ss');
    this.setState({ salonDetails });
  };

  onCloseTimeChange = (dayName, newTime) => {
    const shortDayName = dayName.substring(0, 3).toLowerCase();
    const salonDetails = Object.assign({}, this.state.salonDetails);
    salonDetails[`${shortDayName}_close_time`] = newTime.format('HH:mm:ss');
    this.setState({ salonDetails });
  };

  checkButton = () => void this.setState({ isFooterButtonActive: !this.props.isPosting });
  hideError = () => void this.setState({ errorMessage: '' });

  render() {
    const { isFooterButtonActive, errorMessage, salonDetails } = this.state;
    const { isPosting, currentSalon } = this.props;
    const userName = asObject(currentSalon).name || 'Salon';

    if (!currentSalon) {
      // this is needed because render is called after this.props.history.push('url'); is called ?
      return <div />;
    }

    return (
      <div data-bem="OpeninHoursWrap" className="content-wrap">
        {errorMessage && (
          <PopupModalContainer
            popupTitle="Error"
            popupMessage={errorMessage}
            buttonText="Okay"
            buttonCallback={this.hideError}
          />
        )}

        <HeaderContainer
          titleFirstPart="Let's set "
          userName={userName}
          titleSecondPart=" Opening Time"
          description=""
        />

        <OpeningHoursContainer
          salonDetails={salonDetails}
          onOpenCheckboxChange={this.onOpenCheckboxChange}
          onOpenTimeChange={this.onOpenTimeChange}
          onCloseTimeChange={this.onCloseTimeChange}
        />

        <OnboardingFooter
          isFooterButtonActive={isFooterButtonActive}
          onButtonClick={this.onFooterButtonClicked}
          isLoading={isPosting}
        />

        {isPosting && <div data-bem="OpeninHoursWrap__load-blocker" className="load-blocker" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cognitoUser: state.cognito.user,
  currentSalon: state.currentSalon,
  isPosting: state.currentSalon.isPosting,
  errorMessage: state.currentSalon.errorMessage,
  saved: state.currentSalon.saved,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ updateSalonDetails }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OpeningHoursWrap);
